import { createApp } from 'vue';
import DocToPdfConverter from '@/Components/DocToPdfConverter.vue';
import '@styles/app.css';

createApp(DocToPdfConverter).mount('#doc-to-pdf-converter');
